import React, { useState, useContext, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import { Alert } from '@material-ui/lab'
import PropTypes from 'prop-types'
import { makeStyles, Typography } from '@material-ui/core'
import { SnackBarContext } from '../../../../Components/SnackBar'
import { createUser, updateUserById } from 'Reducers/Users/actions'
import { CheckIcon } from '../../../../Assets/Images/icons/checkIcon'
import { uploadProfileImage } from 'Reducers/Upload/actions'
import { authorization } from '../../../../Module/Auth/Auth'
import { UserManagementIcon } from '../../../../Assets/Images/icons/UserManagementIcon'
import { PATHS } from 'Config/Routing/paths'
import { CreateUserForm } from './CreateUserForm'
import { showReduxModal } from '../../../../Reducers/UI/actions'
import { styles } from './styles'
import StyledBreadcrumbs from '../../../../Components/StyledBreadcrumbs'
import classNames from 'classnames'
import { IfElse } from '../../../../Components/IfElse'
import ArrowBackIcon from '../../../ClientSettings/icons/ArrowBackIcon'

const useStyles = makeStyles(() => styles)

const CreateUserComponent = ({
  createUser,
  updateUserById,
  uploadProfileImage,
  loggedUser,
}) => {
  const history = useHistory()
  const classes = useStyles()
  const runSnackBar = useContext(SnackBarContext)
  const { isVerified = true } = loggedUser

  const user = authorization.getUser() || {}

  const client = useMemo(() => {
    return user.client || {}
  }, [user])

  const [saving, setSaving] = useState(false)

  const handleUpdateAfterCreate = ({ id }, values) => {
    const callbacks = {
      onSuccess: () => userManagementDetailsAddFormSuccess(values),
    }
    uploadProfileImage(id, values.profilePicture, {
      onSuccess: imageUrl =>
        updateUserById(
          id,
          { profile_picture: imageUrl, client_id: user.client.id },
          callbacks,
        ),
    })
  }

  const userManagementDetailsAddFormSubmit = values => {
    setSaving(true)
    const payload = {
      first_name: values.firstName,
      last_name: values.lastName,
      mobile_phone: values.mobilePhone,
      email: values.email,
      password: values.password,
      role: values.role,
      status: 1,
      is_verified: 1,
      profile_picture: undefined,
    }

    if (user.client && user.client.id) {
      payload.client_id = user.client.id
    } else {
      setSaving(false)
      return
    }

    if (values.profilePicture) {
      const callbacks = {
        onSuccess: res => {
          handleUpdateAfterCreate(res, values)
        },
      }
      createUser(payload, callbacks)
    } else {
      const callbacks = {
        onSuccess: () => userManagementDetailsAddFormSuccess(values),
      }
      createUser(payload, callbacks)
    }
  }

  const userManagementDetailsAddFormSuccess = values => {
    runSnackBar({
      type: 'other',
      msg: `New user ${values.firstName} ${
        values.lastName
      } was successfully added`,
      icon: <CheckIcon />,
      horizontal: 'right',
      vertical: 'top',
      newDesign: true,
    })
    history.push(
      `${PATHS.main.dashboard}${PATHS.dashboard.clientSettings}${
        PATHS.clientSettings.userManagement
      }`,
    )
  }
  const onBack = () => {
    history.push(
      PATHS.main.dashboard +
        PATHS.dashboard.clientSettings +
        PATHS.clientSettings.userManagement,
    )
  }

  return (
    <div
      className={classNames(
        classes.profileContainer,
        'makeStyles-profileContainer',
      )}
    >
      <StyledBreadcrumbs
        icon={<UserManagementIcon />}
        breadcrumbs={[
          {
            link: `${PATHS.main.dashboard}${PATHS.dashboard.clientSettings}`,
            label: 'Settings',
          },
          {
            link: `${PATHS.main.dashboard}${PATHS.dashboard.clientSettings}${
              PATHS.clientSettings.userManagement
            }`,
            label: 'User Management',
          },
          {
            label: 'Add User',
          },
        ]}
      />
      <Typography className={classes.profileTitle}>
        <div className={classes.back} onClick={onBack}>
          <ArrowBackIcon />
        </div>
        <div>Add User</div>
      </Typography>

      <div
        className={classNames(
          classes.profileContent,
          'makeStyles-profileContent',
        )}
      >
        <IfElse condition={isVerified}>
          <CreateUserForm
            handleSave={userManagementDetailsAddFormSubmit}
            saving={saving}
            client={client}
          />
          <Alert severity="error">
            Please verify your email to create a new user
          </Alert>
        </IfElse>
      </div>
    </div>
  )
}

CreateUserComponent.propTypes = {
  createUser: PropTypes.func.isRequired,
  updateUserById: PropTypes.func.isRequired,
  uploadProfileImage: PropTypes.func.isRequired,
  loggedUser: PropTypes.object.isRequired,
}

const mapStateToProps = ({ users }) => ({
  loggedUser: users.loggedUser,
})

export const CreateUser = connect(
  mapStateToProps,
  {
    createUser,
    updateUserById,
    uploadProfileImage,
    showReduxModal,
  },
)(CreateUserComponent)
